import { useEffect } from "react";
import { Reveal } from "./Reveal";
import { ContactInfo } from "./ContactInfo";
import { ContactForm } from "./ContactForm";
import { useSimpleForm } from "../hooks/useSimpleForm";

const INITIAL = { name: "", phone: "", email: "", sector: "", offer: "", message: "" };

export const Contact = ({ selectedOffer }) => {
  const { form, setForm, set, submit, loading } = useSimpleForm(INITIAL, "/api/contact", {
    success: "Merci ! Votre demande est bien envoyée, nous vous recontactons très vite.",
    error: "L'envoi a échoué. Appelez-nous directement au 07 84 67 88 02.",
  });

  useEffect(() => {
    if (selectedOffer) setForm((f) => ({ ...f, offer: selectedOffer }));
  }, [selectedOffer, setForm]);

  return (
    <section id="contact" className="px-4 pb-16 pt-4 sm:px-6 sm:pb-24 lg:px-8 lg:pb-32">
      <div className="mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-navy shadow-2xl shadow-navy/40">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <ContactInfo />
          <div className="bg-white p-8 sm:p-12 lg:p-16">
            <Reveal delay={0.1}>
              <ContactForm form={form} set={set} submit={submit} loading={loading} />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
